import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
// import { img2 } from "../_components/imagepath";
// import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import { Apitoken, Authtoken, user_location } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery"; import PropTypes from 'prop-types';

const Option = ({ isSelected, label, ...props }) => {
  return (
    <div>
      <components.Option {...props} isSelected={isSelected} label={label}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => null}
          style={{ marginRight: "8px" }}
        />{" "}
        <label>{label}</label>
      </components.Option>
    </div>
  );
};

Option.propTypes = {
  isSelected: PropTypes.bool,
  label: PropTypes.string,
};

const RmstockAdd = () => {
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [permission, setPermission] = useState({});

  const [productnameLists, setproductnameLists] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [ordersLists, setOrdersLists] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime);

  useEffect(() => {

    formik.setFieldValue('location', user_location);


  }, []); // This will trigger the effect when date_time changes

  


  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${(now.getMonth() + 1) < 10 ? '0' : ''}${now.getMonth() + 1}`;
    const day = `${now.getDate() < 10 ? '0' : ''}${now.getDate()}`;
    const hours = `${now.getHours() < 10 ? '0' : ''}${now.getHours()}`;
    const minutes = `${now.getMinutes() < 10 ? '0' : ''}${now.getMinutes()}`;
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }


  // ✅ Add this helper ABOVE useFormik
  const getInitialShiftAndDate = () => {
    const dt = getCurrentDateTime(); // "YYYY-MM-DDTHH:MM"
    const parts = dt.split("T");
    const datePart = parts[0];
    const timePart = parts[1];

    const [hourStr, minuteStr] = timePart.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const totalMinutes = hour * 60 + minute;

    const shift1Start = 7 * 60 + 30;
    const shift1End = 19 * 60 + 30;
    const shift2End = 7 * 60 + 29;

    if (totalMinutes >= shift1Start && totalMinutes <= shift1End) {
      return { shift: "1", shift_date: datePart };
    } else if (totalMinutes > shift1End) {
      return { shift: "2", shift_date: datePart };
    } else if (totalMinutes <= shift2End) {
      const date = new Date(datePart + "T00:00:00");
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return { shift: "2", shift_date: `${year}-${month}-${day}` };
    }

    return { shift: "1", shift_date: datePart };
  };

  const { shift: initialShift, shift_date: initialShiftDate } = getInitialShiftAndDate();


  const customHandleDateShift = (dateTimeValue) => {
    const dt = dateTimeValue || formik.values.date_time;
    if (!dt) return;

    const parts = dt.includes("T") ? dt.split("T") : dt.split(" ");
    const datePart = parts[0]; // "YYYY-MM-DD"
    const timePart = parts[1]; // "HH:MM"

    if (!timePart) return;

    const [hourStr, minuteStr] = timePart.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const totalMinutes = hour * 60 + minute;

    // Shift boundaries
    const shift1Start = 7 * 60 + 30;  // 07:30 = 450
    const shift1End = 19 * 60 + 30; // 19:30 = 1170
    const shift2Start = 19 * 60 + 31; // 19:31 = 1171
    const shift2End = 7 * 60 + 29;  // 07:29 = 449

    if (totalMinutes >= shift1Start && totalMinutes <= shift1End) {
      // ✅ Shift 1: 07:30 – 19:30 → current day
      formik.setFieldValue("shift", "1");
      formik.setFieldValue("shift_date", datePart);

    } else if (totalMinutes >= shift2Start) {
      // ✅ Shift 2 evening: 19:31 – 23:59 → current day
      formik.setFieldValue("shift", "2");
      formik.setFieldValue("shift_date", datePart);

    } else if (totalMinutes <= shift2End) {
      // ✅ Shift 2 midnight: 00:00 – 07:29 → previous day
      formik.setFieldValue("shift", "2");
      const date = new Date(datePart + "T00:00:00");
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      formik.setFieldValue("shift_date", `${year}-${month}-${day}`);
    }
  };
  const getPalletFromProduct = (event, locationOverride = null) => {
    let para = {
      product: event.value,
      location: locationOverride ?? formik.values.location  // use override if provided
    };
    axios.post(`/raw-materials-stocks/listing-remaining-palletesation`, para, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let orders = response.data.data.palletisation;
        let productslisting = orders.map((shipp, index) => ({
          value: shipp.raw_id,
          label: `${shipp.barcode} (${shipp.lot_number})`,
          key: `farmer-${index}`,
        }));
        setOrdersLists(productslisting);
      }
    }).catch((error) => {
      console.log(error);
    });
  };


  const shifts = [
    { value: 1, label: "1" },
    { value: 2, label: "2" }
  ];

  const formik = useFormik({
    initialValues: {
        date_time: currentDateTime,
      shift: initialShift,      // ✅ auto-detected
      shift_date: initialShiftDate,  // ✅ auto-detected
      product_type: '',
      location: "",
      quantity_processed: "",
      palletesation: [],
      product: "",
    },
    // validationSchema: AddUserSchema,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/rm-stock/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          //actions.setSubmitting(false);
          $("#form-submit").text("Add RM Stock");
          if (response.data.code === 200) {
            // setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/rm-stock";
            }, 1000);
          } else if (response.data.code === 422) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
          else {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console(error);
          // actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    setPermission(FindModuleById(462));
    console.log(permission);
    axios.post(
      "/products/listing-groupby",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          console.log(productnameLists);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));

          setLocationLoading(locations);

        } else {
          console.log("API response is not an array");
        }
      }).catch((error) => {
        console.log(error);
      });


  }, []);

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };


  // Input change cleanup
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  // Updated Select handler for multi-select with checkboxes
  const handleSelectChangemulti = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("palletesation", values);
    customHandleInput({ target: { name: "palletesation", value: values } });
  };




  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Stock</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/rm-stock">Raw Material Stock</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Raw Material Stock
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.add === 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Raw Material Stock Info</h4>
                      <FormikProvider value={formik}>
                        <form action="#" onSubmit={formik.handleSubmit}>
                          <div className="row">


                            <div className="col-md-4">
                              <div className="form-group order status">
                                <label>Location</label>
                                <Select
                                  className="w-100"
                                  value={locationLoading.find(option => option.value == formik.values.location) || null}
                                  name="location"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("location", selectedOption);
                                    // Call pallet fetch if a product is already selected
                                    if (formik.values.product) {
                                      getPalletFromProduct({ value: formik.values.product }, selectedOption.value);
                                    }
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={locationLoading}
                                  placeholder="Select"
                                />
                              </div>
                              <small>
                                {backendErrors.location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.location}
                                  </span>
                                )}
                              </small>
                            </div>
                           

                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Shift Date </label>
                                <input style={{display:'none'}}
                                  type="datetime-local"
                                  name="date_time"
                                  id="date_time"
                                  value={formik.values.date_time}
                                  className="form-input form-control input-error"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                      setCurrentDateTime(e.target.value);
                                    customHandleDateShift(e.target.value); 

                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="date"
                                  name="shift_date"
                                  value={formik.values.shift_date}
                                  className="form-input form-control"

                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);

                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.shift_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift_date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Select Shift </label>

                                <Select
                                  className="w-100"
                                  value={shifts.find(option => option.value == formik.values.shift) || null} // Ensure correct format
                                  name="shift"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("shift", selectedOption);
                                    //   generateLotNumberLocation(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={shifts}
                                  placeholder="Select"
                                />
                                <small>
                                  {backendErrors.shift && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shift}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group order status">
                                <label>Product</label>
                                <Select
                                  className="w-100"
                                  value={productnameLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                  name="product"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("product", selectedOption);
                                    getPalletFromProduct(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={productnameLists}
                                  placeholder="Select"
                                />

                              </div>
                              <small>
                                {backendErrors.product && (
                                  <span className="form-error mt-1">
                                    {backendErrors.product}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Palletesation</label>
                                <input
                                  type="hidden"
                                  name="shift_date"
                                  value={formik.values.shift_date || ""}
                                />
                                <Select
                                  className="w-100"
                                  value={ordersLists.filter((option) =>
                                    formik.values.palletesation.includes(option.value)
                                  )}
                                  name="palletesation"
                                  onChange={handleSelectChangemulti}
                                  onBlur={formik.handleBlur}
                                  options={ordersLists}
                                  placeholder="Select Palletesation"
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  components={{
                                    Option
                                  }}
                                />
                                <small>
                                  {backendErrors.palletesation && (
                                    <span className="form-error mt-1">
                                      {backendErrors.palletesation}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>

                          </div>

                          <small>
                            {backendErrors.status && (
                              <span className="form-error mt-1">
                                {backendErrors.status}
                              </span>
                            )}

                          </small>
                          <div className="text-end mt-4">
                            <button
                              type="submit" id="form-submit"
                              className="btn btn-primary"
                              disabled={formik.isSubmitting}
                            >
                              Add Raw Material Stock
                            </button>
                          </div>
                        </form>
                      </FormikProvider>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RmstockAdd;
